export default [
  {
    path: '/rental/report/MY_008/home_rental_charges',
    name: 'MY_008_DailyHomeRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_008_report" */ './DailyHomeRentalCharges.vue'
      )
  },
  {
    path: '/rental/report/MY_008/income_develop',
    name: 'MY_008_DailyIncomeOfDevelopAndSecuity',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_008_report" */ './DailyIncomeOfDevelop.vue'
      )
  },
  {
    path: '/report/report/MY_008/rental_charges',
    name: 'MY_008_MothlyRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_008_report" */ './MothlyRentalCharges.vue'
      )
  },
  {
    path: '/report/report/MY_008/income_others',
    name: 'MY_008_MothlyIncomeOfOthers',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_008_report" */ './MothlyIncomeOfOthers.vue'
      )
  },
  {
    path: '/report/report/MY_008/balance_due_home_rental',
    name: 'MY_008_MothlyBalanceDueListForHomeRental',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_008_report" */ './MothlyBalanceDueListForHomeRental.vue'
      )
  }
]
